<template>
  <div class="input_container">
    <van-field v-model="localValue" type="number" :placeholder="labelText" @clear="onClear" class="custom-field">
      <!-- Left icon -->
      <template #left-icon>
        <div class="left-section">
          <span class="left_icon"><img src="@/assets/themetwo/footer_1.png" alt="" />BRL</span>
          <div class="divider"></div>
        </div>
      </template>
      <template #right-icon>
        <van-icon v-if="localValue" name="clear" class="custom-clear" @click.stop="onClear" />
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  labelText: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
  localValue.value = newVal
})

watch(localValue, (val) => {
  emit('update:modelValue', val)
  emit('valueChanged', val)
})

const onClear = () => {
  localValue.value = ''
  emit('update:modelValue', '')
  emit('valueChanged', '')
}
</script>

<style scoped>
.input_container>>>.van-field {
  border-radius: 0.5rem;
  background: #2c1d31 !important;
  border: 1px solid #65436f;
  color: #ffffffd9;
  padding: 8px 10px !important;
  margin-top: 10px;
  align-items: center;
}

/* Left "R$" icon */
.left_icon {
  color: #fff;
  font-size: 15px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}

.left_icon img {
  width: 30px;
  padding-right: 5px;
}

.input_container>>>.van-field__control {
  color: #fff !important;
  font-weight: bold;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff40 !important;
  font-weight: 300;
  padding-left: 10px;
  font-size: 13px;
}

.input_container>>>.van-field__clear {
  opacity: 0.5 !important;
}

/* Match same spacing and structure as first input */
.left-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider {
  width: 1px;
  height: 20px;
  background-color: #65436f;
  margin-left: 5px;
}
</style>
